import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
export class AfterSelfieComponent {
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.fotoUrl = yield this.readURL(this.foto);
        });
    }
    readURL(file) {
        return new Promise((res, rej) => {
            const reader = new FileReader();
            reader.onload = (e) => res(e.target.result);
            reader.onerror = (e) => rej(e);
            reader.readAsDataURL(file);
        });
    }
}
